var c = (o, r, t) => new Promise((a, n) => {
  var p = (e) => {
    try {
      i(t.next(e));
    } catch (s) {
      n(s);
    }
  }, y = (e) => {
    try {
      i(t.throw(e));
    } catch (s) {
      n(s);
    }
  }, i = (e) => e.done ? a(e.value) : Promise.resolve(e.value).then(p, y);
  i((t = t.apply(o, r)).next());
});
import { selfAxios as d } from "@oppein/op-utils";
function u(o) {
  return c(this, null, function* () {
    const {
      data: r
    } = yield d.post(
      "/designordercenter/productionOrder/receiver/getPageListByQry",
      o
    );
    return r == null ? void 0 : r.data;
  });
}
export {
  u as postGetPageListByQry
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/request/designordercenter/productionOrder/receiver/getPageListByQry/post.js
// module id = 1818
// module chunks = 67